<template>
    <v-autocomplete
            v-model="model"
            :items="data"
            :label="label"
            :loading="loading"
            :search-input.sync="search"
            multiple
            clearable
            chips
            deletable-chips
            item-value="id"
            item-text="name"
            color="primary"
            :placeholder="$t('inputs.shared.startTypingToSearch')"
    />
</template>

<script>
    export default {
        name: "choose-role",
        props: ['label', 'value'],
        data() {
            return {
                isEditing: false,
                loading: false,
                model: this.value,
                search: null,
                data: [],
                cached: []
            }
        },
        mounted() {
            this.loading = true;
            const params = new URLSearchParams();
            params.append('perPage', "50");
            this.axios.get(this.api.ACTIONS.ROLES, {params})
                .then(res => {
                    const {data: {data}} = res.data;
                    this.data = data.filter(({id}) => id != 1);
                })
                .catch(err => console.log(err))
                .finally(() => this.loading = false);
        },
        watch: {
            model(val) {
                if (val)
                    this.$emit("input", Array.isArray(val) ? val : [val]);
                else this.$emit('input', val);
            }
        }
    }
</script>

<style scoped>

</style>